import React from "react"
import {formatDate} from 'lib/helpers'

const DateValue = ({date, ...rest}) => (
	<span {...rest}>{formatDate(date)}</span>
)
export default DateValue



// WEBPACK FOOTER //
// ./elements/DateValue.jsx